export default __webpack_public_path__ + "static/media/YokaiKindgom_White-1.dc5cd3d0.png";